import { Checkbox } from '@nexelem/components';
import { ChangeEvent } from 'react';
import { useSelectAllStore } from '../store/useSelectAllStore';

type ToDoCheckboxProps = {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  isIntermediate?: boolean;
};

export const ToDoCheckbox = ({ checked, onChange, isIntermediate = false }: ToDoCheckboxProps) => {
  const selectAll = useSelectAllStore((state) => state.selectAll);

  const isChecked = isIntermediate ? false : selectAll ? !checked : checked;

  return (
    <Checkbox checked={isChecked} className="p-2.5" indeterminate={isIntermediate} size="medium" onChange={onChange} />
  );
};

type ToDoCheckboxFilterProps = {
  readonly value: boolean;
  onChange: (value: boolean) => void;
  partialCheck: boolean;
};

export const ToDoCheckboxFilter = ({ onChange, value, partialCheck }: ToDoCheckboxFilterProps) => {
  const handleChange = () => {
    onChange(!value);
  };

  return (
    <Checkbox checked={value} className="p-2.5" indeterminate={partialCheck} size="medium" onChange={handleChange} />
  );
};
